// extracted by mini-css-extract-plugin
module.exports = {"order-form":"style_order-form__DvSPA","trading-tabs-header":"style_trading-tabs-header__40YBO"};